export const PNL_AESTHETIC_PROCEDURES_LINE_ID = 'A2A';

export function isPnlAestheticProceduresLineId(lineId: string): boolean {
  return lineId.trim().toUpperCase() === PNL_AESTHETIC_PROCEDURES_LINE_ID;
}
